export default {
  TITLE_REGISTER: 'Informe as Instruções complementares',
  TITLE_READ: 'Instruções',
  INSTRUCOES: 'Instruções',
};
